import { render, staticRenderFns } from "./orgBulkEditDialog.vue?vue&type=template&id=56394ada&lang=pug"
import script from "./orgBulkEditDialog.vue?vue&type=script&lang=js"
export * from "./orgBulkEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports